var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "image_saver_task" },
    [
      _c(
        "div",
        { staticClass: "image_saver_task_body" },
        [
          _c(
            "div",
            {
              staticClass: "image_saver_task_clear",
              on: {
                click: function($event) {
                  return _vm.clearTask(_vm.activeSubTab)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.imageSaver.clearHistory")))]
          ),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              ref: "imageSaverSubTab",
              staticClass: "image_saver_task_tab",
              on: { "tab-click": _vm.switchTab },
              model: {
                value: _vm.activeSubTab,
                callback: function($$v) {
                  _vm.activeSubTab = $$v
                },
                expression: "activeSubTab"
              }
            },
            [
              _vm.taskNotInit
                ? _c("div", { staticClass: "image_saver_task_not_init" })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  style: {
                    backgroundColor:
                      _vm.tasksSaveOne.length == 0 ? "transparent" : "#FFF"
                  },
                  attrs: {
                    label: _vm.$t("language.imageSaver.taskTabUpload"),
                    name: "saveOne"
                  }
                },
                [
                  _vm.tasksSaveOne.length == 0 && !_vm.taskNotInit
                    ? _c(
                        "div",
                        {
                          staticClass: "image_saver_task_no",
                          style: { height: _vm.noTaskHeight + "px" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "image_saver_task_no_content" },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/images/imageSaver/taskNo.svg")
                                }
                              }),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("language.imageSaver.noTask"))
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tasksSaveOne.length != 0
                    ? _c(
                        "div",
                        { staticClass: "image_saver_task_items" },
                        _vm._l(_vm.tasksSaveOne, function(task, index) {
                          return _c(
                            "div",
                            {
                              key: task.id,
                              staticClass: "image_saver_task_item",
                              class: "image_saver_" + task.status,
                              style: {
                                width: _vm.viewImgWigth + "px",
                                height: _vm.viewImgWigth + "px"
                              }
                            },
                            [
                              _c("img", {
                                class:
                                  "imagesaver_" +
                                  task.fromType +
                                  " imagesaver_" +
                                  task.fromData.type,
                                attrs: {
                                  src: task.fromData.pre
                                    ? task.fromData.pre
                                    : task.fromData.url
                                },
                                on: {
                                  error: function($event) {
                                    return _vm.previewError($event)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              task.fromData.type == "all"
                                ? _c("div", {
                                    staticClass: "image_saver_task_all"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              task.fromData.type == "all"
                                ? _c(
                                    "div",
                                    { staticClass: "image_saver_task_detail" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "detail_success" },
                                        [
                                          _c("img", {
                                            attrs: {
                                              src: require("../../assets/images/imageSaver/insTaskHover.svg")
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.decodeDetail(
                                                  task,
                                                  "success"
                                                ) +
                                                  _vm.decodeDetail(task, "skip")
                                              )
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "detail_error" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("language.common.failed")
                                            ) +
                                              ": " +
                                              _vm._s(
                                                _vm.decodeDetail(task, "error")
                                              )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              task.fromData.type == "video"
                                ? _c("div", {
                                    staticClass: "image_saver_task_video"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              task.status == "create" || task.status == "run"
                                ? _c(
                                    "div",
                                    { staticClass: "image_saver_task_prog" },
                                    [
                                      _c("el-progress", {
                                        attrs: {
                                          type: "circle",
                                          width: 32,
                                          "stroke-width": 16,
                                          percentage: _vm.decodePercentage(
                                            task
                                          ),
                                          "show-text": false,
                                          "define-back-color":
                                            "rgba(0,0,0,0.3)",
                                          color: "#FFF",
                                          "stroke-linecap": "butt"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              task.tempSuccess
                                ? _c("div", {
                                    staticClass: "image_saver_task_success"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              task.status == "error"
                                ? _c("div", {
                                    staticClass: "image_saver_task_error"
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "image_saver_task_cancel",
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelTask(task.id)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("language.imageSaver.cancel"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "image_saver_task_view",
                                  on: {
                                    click: function($event) {
                                      return _vm.viewTask(task)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("language.imageSaver.view"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "image_saver_task_retry",
                                  on: {
                                    click: function($event) {
                                      return _vm.retryTask(task.id)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("language.imageSaver.retry"))
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("language.imageSaver.taskTabSaveAll"),
                    name: "saveAll"
                  }
                },
                [
                  _vm.tasksSaveAll.length == 0 && !_vm.taskNotInit
                    ? _c(
                        "div",
                        {
                          staticClass: "image_saver_task_no",
                          style: { height: _vm.noTaskHeight + "px" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "image_saver_task_no_content" },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/images/imageSaver/taskNo.svg")
                                }
                              }),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(
                                  _vm._s(_vm.$t("language.imageSaver.noTask"))
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tasksSaveAll.length != 0
                    ? _c(
                        "div",
                        { staticClass: "image_saver_width_tasks" },
                        _vm._l(_vm.tasksSaveAll, function(task, index) {
                          return _c(
                            "div",
                            {
                              key: task.id,
                              staticClass: "image_saver_width_task",
                              class: "image_saver_width_" + task.status,
                              attrs: {
                                "data-traffic": _vm.errorIsNoTraffic(task)
                                  ? "Y"
                                  : "N",
                                "data-noprog": _vm.isNoProg(task) ? "Y" : "N",
                                "data-warn": _vm.isWarnNotError(task)
                                  ? "Y"
                                  : "N"
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "image_saver_width_task_icon",
                                class:
                                  "imagesaver_" +
                                  task.fromType +
                                  " imagesaver_" +
                                  task.fromData.type,
                                attrs: {
                                  src: task.fromData.pre
                                    ? task.fromData.pre
                                    : task.fromData.url
                                },
                                on: {
                                  error: function($event) {
                                    return _vm.previewError($event)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "image_saver_width_task_name" },
                                [_vm._v(_vm._s(_vm.taskNameFormat(task)))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "image_saver_width_task_info" },
                                [_vm._v(_vm._s(_vm.decodeWidthInfo(task)))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "image_saver_width_task_prog" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "image_saver_width_task_prog_bg"
                                    },
                                    [
                                      _c("div", {
                                        staticClass:
                                          "image_saver_width_task_prog_cur",
                                        style: {
                                          width: _vm.decodeWidthProg(task)
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "image_saver_width_task_prog_left"
                                    },
                                    [_vm._v(_vm._s(_vm.decodeWidthSpeed(task)))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "image_saver_width_task_prog_right"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.decodeWidthProgText(task))
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "image_saver_width_task_status",
                                  attrs: { msg: _vm.decodeWidthMsgTitle(task) }
                                },
                                [_vm._v(_vm._s(_vm.decodeWidthMsg(task)))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "image_saver_width_task_cancel",
                                  on: {
                                    click: function($event) {
                                      return _vm.cancelTask(task.id)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("language.imageSaver.cancel"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "image_saver_width_task_view",
                                on: {
                                  click: function($event) {
                                    return _vm.viewTask(task)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "image_saver_width_task_retry",
                                on: {
                                  click: function($event) {
                                    return _vm.retryTask(task.id)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.isTrafficNotEnough(),
                                      expression: "isTrafficNotEnough()"
                                    }
                                  ],
                                  staticClass: "image_saver_width_task_upgrade",
                                  on: {
                                    click: function($event) {
                                      return _vm.showUpgradeNewDialog()
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/images/imageSaver/widthUpgrade.svg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "language.rightTopBanner.upgrade"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.isInsTaskList
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("language.imageSaver.taskTabDownload"),
                        name: "downloadAll"
                      }
                    },
                    [
                      _vm.tasksDownloadAll.length == 0 && !_vm.taskNotInit
                        ? _c(
                            "div",
                            {
                              staticClass: "image_saver_task_no",
                              style: { height: _vm.noTaskHeight + "px" }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "image_saver_task_no_content" },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/images/imageSaver/taskNo.svg")
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("language.imageSaver.noTask")
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.tasksDownloadAll.length != 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "image_saver_width_tasks instagram_tasks"
                            },
                            _vm._l(_vm.tasksDownloadAll, function(task, index) {
                              return _c(
                                "div",
                                {
                                  key: task.id,
                                  staticClass: "image_saver_width_task",
                                  class: "image_saver_width_" + task.status,
                                  attrs: {
                                    "data-traffic": _vm.errorIsNoTraffic(task)
                                      ? "Y"
                                      : "N",
                                    "data-overdue": _vm.taskIsOverdue(task)
                                      ? "Y"
                                      : "N",
                                    "data-limit": _vm.taskIsLimit(task)
                                      ? "Y"
                                      : "N",
                                    "data-warn": _vm.isWarnNotError(task)
                                      ? "Y"
                                      : "N",
                                    "data-noprog": _vm.isNoProg(task)
                                      ? "Y"
                                      : "N"
                                  }
                                },
                                [
                                  _c("img", {
                                    staticClass: "image_saver_width_task_icon",
                                    class:
                                      "imagesaver_" +
                                      task.fromType +
                                      " imagesaver_" +
                                      task.fromData.type,
                                    attrs: {
                                      src: task.fromData.pre
                                        ? task.fromData.pre
                                        : task.fromData.url
                                    },
                                    on: {
                                      error: function($event) {
                                        return _vm.previewError($event)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "image_saver_width_task_name2",
                                      on: {
                                        click: function($event) {
                                          return _vm.openInstagramWebPage(task)
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.taskNameFormat(task)))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "image_saver_width_task_info"
                                    },
                                    [_vm._v(_vm._s(_vm.decodeWidthInfo(task)))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "image_saver_width_task_prog"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "image_saver_width_task_prog_bg"
                                        },
                                        [
                                          _c("div", {
                                            staticClass:
                                              "image_saver_width_task_prog_cur",
                                            style: {
                                              width: _vm.decodeWidthProg(task)
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "image_saver_width_task_prog_left"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.decodeWidthSpeed(task))
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "image_saver_width_task_prog_right"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.decodeWidthProgText(task)
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "image_saver_width_task_status",
                                      attrs: {
                                        msg: _vm.decodeWidthMsgTitle(task)
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.decodeWidthMsg(task)))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "image_saver_width_task_overdue"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.decodeWidthOverdue(task))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "image_saver_width_task_cancel",
                                      on: {
                                        click: function($event) {
                                          return _vm.cancelTask(task.id)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("language.imageSaver.cancel")
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isShowDwonloadAllNormal(
                                            task
                                          ),
                                          expression:
                                            "isShowDwonloadAllNormal(task)"
                                        }
                                      ],
                                      staticClass:
                                        "image_saver_width_task_download_all",
                                      on: {
                                        click: function($event) {
                                          return _vm.downloadPart(task, 0, true)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "language.imageSaver.downloadAll"
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "image_saver_width_task_retry",
                                    on: {
                                      click: function($event) {
                                        return _vm.retryTask(task.id)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isShowUpgrade2Btn(task),
                                          expression: "isShowUpgrade2Btn(task)"
                                        }
                                      ],
                                      staticClass:
                                        "image_saver_width_task_upgrade2",
                                      on: {
                                        click: function($event) {
                                          return _vm.showUpgradeNewDialog()
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../assets/images/imageSaver/widthUpgrade.svg")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.rightTopBanner.upgrade"
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isShowDwonloadAllUpgrade(
                                            task
                                          ),
                                          expression:
                                            "isShowDwonloadAllUpgrade(task)"
                                        }
                                      ],
                                      staticClass:
                                        "image_saver_width_task_upgrade2_download_all",
                                      on: {
                                        click: function($event) {
                                          return _vm.showUpgradeNewDialog()
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../assets/images/imageSaver/widthUpgrade.svg")
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "language.imageSaver.downloadAll"
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isShowDwonloadAllNormal(
                                            task
                                          ),
                                          expression:
                                            "isShowDwonloadAllNormal(task)"
                                        }
                                      ],
                                      staticClass:
                                        "image_saver_width_task_parts"
                                    },
                                    _vm._l(_vm.decodeWidthParts(task), function(
                                      part,
                                      index2
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: part.uuid,
                                          staticClass:
                                            "image_saver_width_task_part",
                                          attrs: {
                                            "data-status": part.flag
                                              ? "yes"
                                              : "no"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.downloadPart(
                                                task,
                                                index2 + 1,
                                                part.flag
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticClass:
                                              "image_saver_width_task_part_zip",
                                            attrs: {
                                              src: require("../../assets/images/imageSaver/partZip.svg")
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "image_saver_width_task_part_num"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "language.imageSaver.taskPart"
                                                  ) +
                                                    " " +
                                                    (index2 + 1)
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("img", {
                                            staticClass:
                                              "image_saver_width_task_part_download",
                                            attrs: {
                                              src: require("../../assets/images/imageSaver/partDownload.svg")
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("img", {
                                            staticClass:
                                              "image_saver_width_task_part_upgrade",
                                            attrs: {
                                              src: require("../../assets/images/imageSaver/partUpgrade.svg")
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "image_saver_width_task_part_info"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  part.flag
                                                    ? _vm.filesUnitText(
                                                        part.count
                                                      ) +
                                                        "(" +
                                                        _vm.formatBytes(
                                                          part.size
                                                        ) +
                                                        ")"
                                                    : ""
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "task-buttom" }),
      _vm._v(" "),
      _c("upgradeVipDialog", { ref: "upgradeVipDialog" }),
      _vm._v(" "),
      _c("upgradeNewDialog", { ref: "upgradeNewDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65bc6c1d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65bc6c1d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/image_saver_task.vue
// module id = null
// module chunks = 